/**
 * Notes that named you.
 *
 * THIS IS THE HALF THAT WAS NEVER BUILT. Entries were written to
 * orgs/{orgId}/mentions from the day notes shipped - no callable read them, no
 * screen showed them, no rule would have let a browser try. They accumulated
 * unread for months while the code comments described a bell that did not
 * exist. A colleague typing "@you" was, in practice, talking to nobody.
 *
 * A LIST RATHER THAN A POPOVER. A count that clears on sight is worth very
 * little for something you may need to act on days later; a page you can come
 * back to answers "who asked me to look at what, and when?" long after the
 * badge has gone. Read rather than deleted, for the same reason.
 *
 * The rows and the bell read the same store, so clicking one clears the badge
 * immediately rather than at the end of the next poll.
 */

import { useEffect } from 'react';
import { useMentions, refresh, markRead } from './mentionStore';

function when(ms: number): string {
  if (!ms) return '';
  return new Date(ms).toLocaleString(undefined, {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export function MentionsPanel({ orgId }: { orgId: string }) {
  const { mentions, loaded, error, unread } = useMentions();

  useEffect(() => { void refresh(orgId); }, [orgId]);

  return (
    <section className="panel">
      <div className="row-between">
        <div>
          <h3 className="panel-title">Mentions</h3>
          <p className="panel-note" style={{ marginBottom: 0 }}>
            Notes where a colleague typed your name. Click one to mark it read — they are kept
            rather than deleted, because the note is still there and “who asked me to look at
            this?” is a question that outlives the badge.
          </p>
        </div>
        {unread > 0 && (
          <button
            className="btn"
            onClick={() => void markRead(orgId, mentions.filter((m) => !m.seen).map((m) => m.id))}
          >
            Mark all read ({unread})
          </button>
        )}
      </div>

      {error && <div className="banner banner-error">{error}</div>}

      {!loaded ? (
        <div className="empty">Loading.</div>
      ) : mentions.length === 0 ? (
        <div className="empty">
          Nobody has mentioned you. A colleague types @ and picks your name in a note on a machine
          or a client, and it appears here and in your email.
        </div>
      ) : (
        <table className="mini-table">
          <thead>
            <tr><th /><th>When</th><th>From</th><th>About</th><th>What they wrote</th></tr>
          </thead>
          <tbody>
            {mentions.map((m) => (
              /*
               * THE WHOLE ROW IS THE TARGET, not a small control at the end.
               * Reading it IS the act that makes it read, so the thing you
               * click should be the thing you were already looking at.
               */
              <tr
                key={m.id}
                className={m.seen ? 'mention-row' : 'mention-row is-unread'}
                onClick={() => void markRead(orgId, [m.id])}
                title={m.seen ? undefined : 'Click to mark read'}
              >
                <td>{!m.seen && <span className="tag tag-note">new</span>}</td>
                <td className="dim" style={{ fontSize: 11, whiteSpace: 'nowrap' }}>{when(m.atMs)}</td>
                <td style={{ fontSize: 12 }}>{m.byEmail}</td>
                <td style={{ fontSize: 12 }}>
                  {m.label || m.key}
                  <span className="dim" style={{ fontSize: 10, display: 'block' }}>
                    {m.scope === 'client' ? 'client note' : 'machine note'}
                  </span>
                </td>
                <td style={{ fontSize: 12 }}>{m.excerpt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
